module.exports = __webpack_public_path__ + "static/media/stories.d7322527.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/stories.png
// module id = 677
// module chunks = 1